import { Icon } from '@sravni/react-design-system';
import type { IconProps } from '@sravni/react-design-system/dist/types/components/Icon/types/Icon.types';
import type { FC } from 'react';
import React, { useMemo } from 'react';

import EsiaLogo from './EsiaLogo.svg';

type IAuthenticationESIAButton = {
  background?: IconProps['background'];
  size?: IconProps['size'];
  className?: string;
};

export const AuthenticationEsiaIcon: FC<IAuthenticationESIAButton> = ({ background, size = 28, className }) => {
  const additionalProps: Record<string, string | undefined> = useMemo(() => {
    if (background) {
      return { background, shape: 'round' };
    }

    return {};
  }, [background]);

  return (
    <Icon
      className={className}
      icon={<EsiaLogo />}
      size={size}
      {...additionalProps}
    />
  );
};
